// extracted by mini-css-extract-plugin
export default {"root":"ErrorNotify_root__dKLb0","layout-container":"ErrorNotify_layout-container__EKfgt","content":"ErrorNotify_content__irblf","button":"ErrorNotify_button__Ac3Sm","text":"ErrorNotify_text__Nf0S2"};
    if(module.hot) {
      // 1763446807817
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  